<div modalHeader class="modal-header py-2">
  <div class="d-flex flex-row justify-content-between align-items-center w-100">
    <h2 class="my-1">Copy settings</h2>

    <tr-icon [icon]="icon.cancel" classes="close-btn" (click)="close()"></tr-icon>
  </div>
</div>

<div modalContent #contentRef class="modal-body" *ngIf="location">
  <div #alertRef>
    <ngb-alert [dismissible]="false" type="info">
      <p class="mb-0">SOURCE LOCATION</p>
      <h6 class="font-weight-bold" [innerText]="location.name"></h6>
    </ngb-alert>
  </div>

  <form [formGroup]="form">
    <div class="checkbox-groups" *ngIf="locationsToDisplay.length > 0">
      <div class="checkbox-group">
        <div class="group-left">
          <p class="mb-0" #leftTextRef>
            Please choose the target target location(s) to which you want to apply the settings of the source location.
            Note that some settings won't be overwritten (e.g., name, address, URL, timezone, users & permissions, etc.).
          </p>

          <tablesready-checkbox-group
            [selectAll]="true"
            formControlName="locationIds"
            [items]="locationsToDisplay"
            [contentStyle]="{ 'max-height': contentLeftMaxHeight + 'px', 'overflow-y': 'auto', 'padding-bottom': '1px' }"
            searchTitle="Location"
            searchPlaceholder="Search locations"
            selectAllTitle="All locations"
          ></tablesready-checkbox-group>
        </div>
      </div>
      <div class="checkbox-group">
        <div class="group-right">
          <p #textRef>Specify which settings groups you want to apply to the chosen location(s).</p>

          <tablesready-checkbox-group
            [selectAll]="true"
            formControlName="settings"
            [items]="settingsToCopy"
            [contentStyle]="{ 'max-height': contentRightMaxHeight + 'px', 'overflow-y': 'auto', 'padding-bottom': '1px' }"
            searchTitle="Settings"
            searchPlaceholder="Search settings"
            selectAllTitle="All settings groups"
            [displaySearch]="false"
          ></tablesready-checkbox-group>
        </div>
      </div>
    </div>
  </form>
</div>

<div modalFooter class="d-flex flex-row justify-content-center p-3">
  <button
    class="btn btn-info mr-2 px-5"
    [disabled]="isFormInvalid"
    (click)="save()"
  >Apply</button>
  <button class="btn btn-danger ml-2 px-5" (click)="close()">Cancel</button>
</div>
